export const storageGetItem = (key) => {
  return localStorage.getItem(key);
};

export const storageSetItem = (key, value) => {
  localStorage.setItem(key, value);
};

export const storageRemoveItem = (key) => {
  localStorage.removeItem(key);
};
